module.exports = __webpack_public_path__ + "static/media/selcare-big.d815a14f.png";